import React from 'react';
import { componentService } from 'js/services/component.service';

export const CashierIframe = React.lazy(() => import(/* webpackChunkName: "cashier-iframe" */ './CashierIframe'));

componentService.registerPageComponents({ 'cashier-iframe': CashierIframe });
